import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './redux/store';

if (process.env.NODE_ENV === 'development') {
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    trackHooks: true,
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
